
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Talent Exploration</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm itoohavetalent section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>I Too Have A <span > Talent 2023</span></h2>
        </div>

        <div class="row justify-content-center align-items-center row-cols-1">
            <div class="col mb-4">
                <div class="row g-2">
                    <div class="col">
                        <a href="/itoohavetalent-2022#oratory">
                            <div class="talent-div">
                                <div class="talent-img"
                                    style="background-image: url(https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/oratory.jpg);">
                                </div>
                                <div class="text-center text-white p-2">
                                    <h6 class="text-white mb-0">Oratory Competition</h6>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col">
                        <a href="/itoohavetalent-2022#dance">
                            <div class="talent-div">
                                <div class="talent-img"
                                    style="background-image: url(https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/dance.jpg);">
                                </div>
                                <div class="text-center text-white p-2">
                                    <h6 class="text-white mb-0">Dance Competition</h6>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col">
                        <a href="/itoohavetalent-2022#singing">
                            <div class="talent-div">
                                <div class="talent-img"
                                    style="background-image: url(https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/singing.jpg)">
                                </div>
                                <div class="text-center text-white p-2">
                                    <h6 class="text-white mb-0">Singing Competition</h6>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col">
                        <a href="/itoohavetalent-2022#stand-up">
                            <div class="talent-div">
                                <div class="talent-img"
                                    style="background-image: url(https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/stand-up.jpg)">
                                    <!-- <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/stand-up.jpg" alt="GHRSCF"> -->
                                </div>
                                <div class="text-center text-white p-2">
                                    <h6 class="text-white mb-0">Comedy Competition</h6>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col">
                        <a href="/itoohavetalent-2022#reel">
                            <div class="talent-div">
                                <div class="talent-img"
                                    style="background-image: url(https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/reel.jpg)">
                                    <!-- <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/reel.jpg" alt="GHRSCF"> -->
                                </div>
                                <div class="text-center text-white p-2">
                                    <h6 class="text-white mb-0">Reel Competition</h6>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col">
                        <a href="/itoohavetalent-2022#photography">
                            <div class="talent-div">
                                <div class="talent-img"
                                    style="background-image: url(https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/photography.jpg)">
                                    <!-- <img class="img-fluid" src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/photography.jpg" alt="GHRSCF"> -->
                                </div>
                                <div class="text-center text-white p-2">
                                    <h6 class="text-white mb-0">Photography Competition</h6>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row row-cols-2 g-5 my-3">
                    <div class="col m-0  text-center">
                        <a href="/photogallery#itoohave-talent" class="cmn-button">
                            Photo Gallery

                        </a>
                    </div>
                    <div class="col m-0  text-center">
                        <a href="https://drive.google.com/file/d/1xqStl_fxSCQM6UzXMW5CYTUnbPaIQ7GC/view?usp=sharing"
                            target="_Blank" class="cmn-button">
                            View Result

                        </a>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="up-event" id="dance">
                    <div class="row">

                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/dance.jpg"
                                alt="GHRSCF">
                        </div>


                        <div class="col-md-8 up-event-text">
                            <div class="widget_title inner-title">
                                <h4 class="fw-bold">The Group Dance/Duet Dance Competition</h4>
                            </div>
                            <h6 class="fw-bold">Rules & Regulations</h6>
                            <ul class="list-style list-style1">
                                <li>The competition is open to all students currently studying in any of the Rasioni
                                    colleges.</li>
                                <li>Group Participants should be minimum of 2 & maximum of 6 participants.</li>
                                <li>Duration of performance: 3 minutes. Exceeding the time may lead to a deduction in
                                    marks.</li>
                                <li>Cinema songs are allowed.</li>
                                <li>Contemporary styles only.</li>
                                <li>Use of vulgar, sexually explicit or violent language and/or lyrics is strictly
                                    prohibited.</li>
                                <li>The participants in group dance should be registered individually.</li>
                                <li>Judgment is based on the basis of rhythm, formation, expression, costumes, makeup,
                                    sets on the overall effect.</li>
                                <li>Follow the upload guidelines to share the performance video.</li>
                                <li>Judges decision will be final & no interference from colleges will be entertained.
                                </li>
                                <li> last date of submission the video of dance competition is 22nd Jan'23</li>
                                <li> Send your video sample for entry to <a
                                        href="mailto:pro@raisoni.net">pro@raisoni.net</a>.</li>
                                <li> Final competition will be held at GHRCE, Nagpur on date _______</li>
                                <li> All the videos will be posted on youtube. </li>

                            </ul>
                            <a href="https://bit.ly/3VnmLOZ" class="cmn-button"
                                target="_blank"> Register Here
                            </a>
                        </div>
                    </div>
                </div>
                <div class="up-event" id="singing">
                    <div class="row">

                        <div class="col-md-4 order-2">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/singing.jpg"
                                alt="GHRSCF">
                        </div>


                        <div class="col-md-8 up-event-text">
                            <div class="widget_title inner-title">
                                <h4 class="fw-bold">The Solo Singing Competition</h4>
                            </div>
                            <h6 class="fw-bold">Rules & Regulations</h6>
                            <ul class="list-style list-style1">
                                <li>The competition is open to all students currently studying in any of the Rasioni
                                    colleges.</li>
                                <li>Audio recording should be clear.</li>
                                <li>Song should be in Hindi/English/Marathi but there will be no separate category for
                                    prizes.</li>
                                <li>Singing with karaoke is not allowed for the scrutiny round though live orchestra
                                    will remain available for the final competition at Nagpur. Exceeding the time may
                                    lead to deduction in marks.</li>
                                <li>Judges decision will be final.</li>
                                <li>Last date of submission audio recording is 22nd Jan'23 </li>
                                <li>Audio recording should be mailed to <a
                                        href="mailto:pro@raisoni.net">pro@raisoni.net</a>.</li>
                                <li>Details of song that will be sung during the final event have to be informed well in
                                    advance.</li>
                                <li>Final competition will be held at GHRCE, Nagpur on date _______</li>
                                <li>All the videos will be posted on youtube.</li>
                            </ul>
                            <a href="https://bit.ly/3VnmLOZ" class="cmn-button"
                                target="_blank"> Register Here

                            </a>
                        </div>
                    </div>
                </div>
                <div class="up-event" id="stand-up">
                    <div class="row">

                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/stand-up.jpg"
                                alt="GHRSCF">
                        </div>


                        <div class="col-md-8 up-event-text">
                            <div class="widget_title inner-title">
                                <h4 class="fw-bold">The Open Mic Stand-up Comedy competition</h4>
                            </div>
                            <h6 class="fw-bold">Rules & Regulations</h6>
                            <ul class="list-style list-style1">
                                <li>The competition is open to all students currently studying in any of the Rasioni
                                    colleges.</li>
                                <li>It is a solo competition. </li>
                                <li>participant should send video along with registration details </li>
                                <li>Time limit is 4 min. exceeding the time limit may lead to deduction in marks </li>
                                <li>Participant will be judged on the basis of content, fluency, spontaneity,
                                    presentation & sense of humour.</li>
                                <li>Use of slangs, abusive & vulgar language is strictly prohibited.</li>
                                <li>No political topic is allowed.</li>
                                <li>Video recording should be mailed to <a
                                        href="mailto:pro@raisoni.net">pro@raisoni.net</a></li>
                                <li>Decision of judges will be final. </li>
                                <li>Last date of submission the video clip is 22nd Jan'23.</li>
                                <li>Final competition will be held at GHRCE, Nagpur on date _______</li>
                                <li>All the videos will be posted on youtube.</li>
                            </ul>
                            <a href="https://bit.ly/3VnmLOZ" class="cmn-button"
                                target="_blank"> Register Here

                            </a>
                        </div>
                    </div>
                </div>
                <div class="up-event" id="reel">
                    <div class="row">

                        <div class="col-md-4 order-2">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/reel.jpg"
                                alt="GHRSCF">
                        </div>


                        <div class="col-md-8 up-event-text">
                            <div class="widget_title inner-title">
                                <h4 class="fw-bold">The Reel making Competition</h4>
                            </div>
                            <h6 class="fw-bold">Rules & Regulations</h6>
                            <ul class="list-style list-style1">
                                <li>The competition is open to all students currently studying in any of the Rasioni
                                    colleges.</li>
                                <li>The time limit for the reel is 3mins.</li>
                                <li>Content should be based on the theme </li>
                                <ol>
                                    <li>The Stereotype & society</li>
                                    <li>My city My Pride</li>
                                </ol>
                                <li>Content should not contain any violent, obscene, defamatory content or music.
                                    Finding so will be eliminated.</li>
                                <li>Selected reels will be uploaded on our social media platforms. </li>
                                <li>Last date of submission is 22nd Jan'23.</li>
                                <li>Send your entry to pro@raisoni.net</li>

                            </ul>
                            <a href="https://bit.ly/3VnmLOZ" class="cmn-button"
                                target="_blank"> Register Here

                            </a>
                        </div>
                    </div>
                </div>
                <div class="up-event" id="photography">
                    <div class="row">

                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/photography.jpg"
                                alt="GHRSCF">
                        </div>


                        <div class="col-md-8 up-event-text">
                            <div class="widget_title inner-title">
                                <h4 class="fw-bold">The Photography competition</h4>
                            </div>
                            <h6 class="fw-bold">Rules & Regulations</h6>
                            <ul class="list-style list-style1">
                                <li>The competition is open to all students currently studying in any of the Rasioni
                                    colleges.</li>
                                <li>The theme of the photography competition is Nature & Animal </li>
                                <li>Only one entry per participant is allowed.</li>
                                <li>Use of filter is not allowed.</li>
                                <li>Only original work would be considered.</li>
                                <li>Photography should be either JPG,JPEG or PNG format.</li>
                                <li>The photograph must be of the highest resolution possible.</li>
                                <li>A caption must be given to the photograph.</li>
                                <li>It should be not large as 10 MB.</li>
                                <li>The decision of the judges will be final.</li>
                                <li>Last date of the entry is 22nd Jan'23</li>
                                <li>Send your entries to <a href="mailto:pro@raisoni.net">pro@raisoni.net</a></li>
                            </ul>
                            <a href="https://bit.ly/3VnmLOZ" class="cmn-button"
                                target="_blank"> Register Here

                            </a>
                        </div>
                    </div>
                </div>
                <div class="up-event" id="oratory">
                    <div class="row">

                        <div class="col-md-4 order-2">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/talent-22/oratory.jpg"
                                alt="GHRSCF">
                        </div>


                        <div class="col-md-8 up-event-text">
                            <div class="widget_title inner-title">
                                <h4 class="fw-bold">The Oratory competition</h4>
                            </div>
                            <h6 class="fw-bold">Rules & Regulations</h6>
                            <ul class="list-style list-style1">
                                <li>The competition is open to all students currently studying in any of the Raisoni
                                    colleges.</li>
                                <li>This oration is composed and memorized by the contestant who delivers it.</li>
                                <li>The theme of the speech shall fall within one of the following categories:
                                    <ol>
                                        <li>1. Reality shows are a source of exploitation.</li>
                                        <li>2. Sports can boost learning effectiveness.</li>
                                        <li>3. Political unrest decelerates economic growth.</li>
                                    </ol>
                                </li>
                                <li>The original oration will be no longer than Three (3) minutes. Speeches will be
                                    timed.</li>
                                <li> Since these orations have been written by the contestants delivering them, the
                                    judges will watch for thought, composition and delivery. However, since this is a
                                    contest in speech, emphasis will be placed on the speech phase. Thought and
                                    composition will be considered primarily in the way they are employed to make the
                                    speech effective.</li>
                                <li>The orator is expected to discuss intelligently, with a degree of originality, in an
                                    interesting manner, and with some profit to the audience, the chosen topic.</li>
                                <li>Delivery will be judged for mastery of the usual mechanics of speech --- poise,
                                    quality and use of voice, and bodily effectiveness --- and for the qualities of
                                    directness and sincerity which impress the oration on the mind of the audience.</li>
                            </ul>
                            <a href="https://bit.ly/3VnmLOZ" class="cmn-button"
                                target="_blank"> Register Here
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
